import React, { useState, useEffect } from "react";
import { customerReviews } from "../Scripts/reviews";
import "../Styles/Reviews.css";
import { useTranslation } from 'react-i18next';

function Reviews() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'he'; // Check if the current language is Hebrew
  const [review, setReview] = useState(0);
  const [reviewData, setReviewData] = useState({ message: '', name: '', location: '' });

  // Navigate to previous or next review
  const navigateReview = (direction) => {
    setReview(prev => {
      const newIndex = direction === 'next' ? (prev + 1) % customerReviews.length : (prev - 1 + customerReviews.length) % customerReviews.length;
      handleReviewsUpdation(newIndex);
      return newIndex;
    });
  };

  // Update reviews display
  const handleReviewsUpdation = (index) => {
    const reviewMessage = customerReviews[index];
    setReviewData({
      message: reviewMessage.message,
      name: reviewMessage.name,
      location: reviewMessage.location,
    });
  };

  // Initialize review data on mount and when review index changes
  useEffect(() => {
    handleReviewsUpdation(review);
  }, [review]);

  return (
    <div className={`review-section ${isRTL ? 'rtl' : ''}`} id="reviews">
      <div className="rw-text-content">
        <p className="rw-text-title">
          {t('customersReview', { count: 1500 })} {/* Dynamic count */}
        </p>

        <p className="rw-text-desc">{t('checkClientsWords')}</p>

        <p className="rw-text-format">
          <span className="rw-text-quote1">''</span>
          <span className="rw-review">{reviewData.message}</span>
          <span className="rw-text-quote2">''</span>
        </p>

        <div className="rw-authors">
          <div className="rw-names">
            <p className="rw-reviewer-name">{reviewData.name}</p>
            <p className="rw-reviewer-place">{reviewData.location}</p>
          </div>

          <div className="rw-btns">
            <button
              className="rw-next-btn"
              type="button"
              onClick={() => navigateReview('back')}
            >
              ←
            </button>
            <button
              className="rw-next-btn"
              type="button"
              onClick={() => navigateReview('next')}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews;
